import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsSupportTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['support']> = {
  zh: {
    cardLogisticsIssuesTitle: '物流异常',
    sectionInternationalTitle: '国际物流',
    internationalLostTitle: '商品丢失',
    internationalLostDescription: 'Goods are lost in transit.',
    internationalSeizedTitle: '商品被查没',
    internationalSeizedDescription: '商品和申报信息完全合规，但被海关等监管部门查没。',
    internationalDelayedTitle: '延误送达',
    internationalDelayedDescription: '海运超过30天、空运超过10天仍未送达海外仓。',
    sectionWarehouseTitle: '海外仓',
    warehouseInboundDelayTitle: '延迟入库',
    warehouseInboundDelayDescription: '收货超过5天仍未上架。',
    warehouseOutboundDelayTitle: '延迟出库',
    warehouseOutboundDelayDescription: '提交入库单超过48小时仍未出库。',
    warehouseLostTitle: '商品丢失',
    warehouseLostDescription: '商品在海外仓丢失。',
    warehouseDamagedTitle: '商品损坏',
    warehouseDamagedDescription: '商品在海外仓损坏。',
    sectionExpressTitle: '海外快递',
    expressNoTrackingTitle: '出库后无轨迹',
    expressNoTrackingDescription: '长时间无物流轨迹。',
    expressNotDeliveredTitle: '出库后未送达',
    expressNotDeliveredDescription: '轨迹长时间未更新，或快递公司显示已签收但买家未收到。',
    expressInvalidLabelTitle: '虚假面单',
    expressInvalidLabelDescription: '通过海海购买的快递面单被快递公司判定为虚假且申诉无效',
    cardOmsIssuesTitle: 'OMS异常',
    sectionOmsInboundTitle: '新建入库单',
    omsInboundCannotSubmitTitle: '入库单无法提交',
    omsInboundCannotSubmitDescription: '入库单中的商品未审核导致，请联系海海客服。',
    sectionOmsOutboundTitle: '新建出库单',
    omsOutboundFetchFailedTitle: '平台订单获取失败',
    omsOutboundFetchFailedDescription: '店铺授权、产品配对不正确导致，请重新设置。',
    omsOutboundLabelFailedTitle: '平台面单请求失败',
    omsOutboundLabelFailedDescription: '面单已在平台中被打印导致，请在电商平台中取消该面单。',
    omsOutboundHaiLabelFailedTitle: '海面单请求失败',
    omsOutboundHaiLabelFailedDescription: '海海快递系统故障导致，请联系海海客服。',
    sectionOmsOtherTitle: '其他',
    omsOtherChargeMismatchTitle: '扣费金额错误',
    omsOtherChargeMismatchDescription: '商品、入库单、出库单、退件单中的数量、尺寸、重量错误导致，请联系海海客服修改。',
    omsOtherGeneralIssueTitle: '其他报错和问题',
    omsOtherGeneralIssueDescription: '请联系OMS右上角的客服机器人获取帮助。',
    actionClaim: '索赔',
    actionRules: '规则',
    actionEscalate: '催促',
    actionReship: '补发',
    actionContactHaiHai: '联系海海客服',
    actionGuide: '操作指引',
    actionContactOms: '联系OMS客服',
    lockedTitle: '处理异常情况',
    lockedDescription: '获得完整的异常处理指南和索赔规则，涵盖国际物流丢失、海关查没、海外仓损坏、快递无轨迹等场景。明确的责任划分和赔偿标准，安心经营无忧。',
    lockedFeature1: '物流异常处理和索赔规则',
    lockedFeature2: '海外仓丢损赔偿标准',
    lockedFeature3: '快递问题补发和追踪',
    lockedFeature4: 'OMS使用问题快速解决',
    lockedActionOpenAccount: '立即开户',
    lockedActionContactSupport: '联系客服',
  },
  en: {
    cardLogisticsIssuesTitle: 'Logistics exceptions',
    sectionInternationalTitle: 'International shipping',
    internationalLostTitle: 'Lost shipment',
    internationalLostDescription: 'Products are lost during transportation.',
    internationalSeizedTitle: 'Seized by customs',
    internationalSeizedDescription: 'Goods and declarations are compliant, but still seized by customs or regulators.',
    internationalDelayedTitle: 'Delayed arrival',
    internationalDelayedDescription: 'Sea freight takes over 30 days, or air freight takes over 10 days to reach the overseas warehouse.',
    sectionWarehouseTitle: 'Overseas warehouse',
    warehouseInboundDelayTitle: 'Inbound delay',
    warehouseInboundDelayDescription: 'Products are still not shelved 5+ days after warehouse receipt.',
    warehouseOutboundDelayTitle: 'Outbound delay',
    warehouseOutboundDelayDescription: 'No outbound after 48+ hours since outbound order submission.',
    warehouseLostTitle: 'Lost goods',
    warehouseLostDescription: 'Goods are lost in the overseas warehouse.',
    warehouseDamagedTitle: 'Damaged goods',
    warehouseDamagedDescription: 'Goods are damaged in the overseas warehouse.',
    sectionExpressTitle: 'Last-mile courier',
    expressNoTrackingTitle: 'No tracking after dispatch',
    expressNoTrackingDescription: 'No tracking updates for an extended period.',
    expressNotDeliveredTitle: 'Not delivered after dispatch',
    expressNotDeliveredDescription: 'Tracking is stale for a long time, or marked delivered but buyer did not receive it.',
    expressInvalidLabelTitle: 'Invalid label',
    expressInvalidLabelDescription: 'A label purchased via HaiHai is judged invalid by the courier and appeal fails.',
    cardOmsIssuesTitle: 'OMS exceptions',
    sectionOmsInboundTitle: 'Create inbound order',
    omsInboundCannotSubmitTitle: 'Inbound order cannot be submitted',
    omsInboundCannotSubmitDescription: 'Products in the inbound order are not approved. Please contact HaiHai support.',
    sectionOmsOutboundTitle: 'Create outbound order',
    omsOutboundFetchFailedTitle: 'Failed to fetch platform orders',
    omsOutboundFetchFailedDescription: 'Caused by incorrect store authorization or product mapping. Please reconfigure.',
    omsOutboundLabelFailedTitle: 'Failed to request platform label',
    omsOutboundLabelFailedDescription: 'The label was already printed on the platform. Cancel it in the e-commerce platform and retry.',
    omsOutboundHaiLabelFailedTitle: 'HaiHai label request failed',
    omsOutboundHaiLabelFailedDescription: 'Caused by HaiHai courier system issues. Please contact HaiHai support.',
    sectionOmsOtherTitle: 'Others',
    omsOtherChargeMismatchTitle: 'Incorrect charge amount',
    omsOtherChargeMismatchDescription: 'Caused by incorrect quantity, dimensions, or weight in products/inbound/outbound/return orders. Contact HaiHai support for correction.',
    omsOtherGeneralIssueTitle: 'Other errors and issues',
    omsOtherGeneralIssueDescription: 'Please contact the OMS support bot at the top-right corner for help.',
    actionClaim: 'Claim',
    actionRules: 'Rules',
    actionEscalate: 'Escalate',
    actionReship: 'Reship',
    actionContactHaiHai: 'Contact HaiHai support',
    actionGuide: 'Guide',
    actionContactOms: 'Contact OMS support',
    lockedTitle: 'Handle exceptions',
    lockedDescription: 'Get complete exception-handling guides and claim rules for international loss, customs seizure, warehouse damage, and no-tracking scenarios. Clear liability boundaries and compensation standards help you operate with confidence.',
    lockedFeature1: 'Logistics exception handling and claim rules',
    lockedFeature2: 'Compensation standards for overseas warehouse loss/damage',
    lockedFeature3: 'Reshipment and tracking support for courier issues',
    lockedFeature4: 'Fast resolution for OMS usage issues',
    lockedActionOpenAccount: 'Open account',
    lockedActionContactSupport: 'Contact support',
  },
};
